export const SUPPORT_CATEGORIES = [
  "Login & Account",
  "Appointments & Consultation",
  "Pet & Client Records",
  "EMR & Medical Records",
  "Billing & Payments",
  "Inventory & Pharmacy",
  "Diagnostics",
  "Reports & Documents",
  "User & Access Management",
  "Performance & Technical Issues",
  "Hardware & Printing",
  "How-To / Training",
  "Feature Request",
  "Other",
];

export const SUPPORT_REASONS_BY_CATEGORY = {
  "Login & Account": [
    "Unable to log in",
    "Forgot password / Reset password",
    "Account locked",
    "Password change issue",
    "Session / logout issue",
    "Other login/account issue",
  ],
  "Appointments & Consultation": [
    "Unable to create appointment",
    "Unable to reschedule appointment",
    "Unable to cancel appointment",
    "Appointment not visible",
    "Appointment status incorrect",
    "Doctor/Vet not available for appointment",
    "Consultation cannot be started",
    "Consultation cannot be completed",
    "Appointment/consultation workflow issue",
    "Other appointment issue",
  ],
  "Pet & Client Records": [
    "Unable to create pet",
    "Unable to create pet parent",
    "Existing pet/client not found",
    "Duplicate pet/client",
    "Incorrect pet/client information",
    "Unable to edit pet/client information",
    "Pet linked to incorrect client",
    "Pet history not showing",
    "Search issue",
    "Other pet/client issue",
  ],
  "EMR & Medical Records": [
    "SOAP note issue",
    "Vitals issue",
    "Prescription issue",
    "Diagnostics issue",
    "Treatment plan issue",
    "Procedure/treatment record issue",
    "EMR history missing/incorrect",
    "Unable to save medical record",
    "Unable to edit medical record",
    "Discharge note issue",
    "Medical document/print issue",
    "Other EMR issue",
  ],
  "Billing & Payments": [
    "Unable to create estimate",
    "Unable to convert estimate to bill",
    "Unable to create bill",
    "Incorrect bill amount",
    "Incorrect discount/tax",
    "Payment not recorded",
    "Payment recorded incorrectly",
    "Payment not reflected in collection",
    "Advance/unapplied credit issue",
    "Refund issue",
    "Invoice/receipt issue",
    "Bill cannot be closed",
    "Payment reconciliation issue",
    "Other billing issue",
  ],
  "Inventory & Pharmacy": [
    "Unable to create inventory item",
    "Item not appearing",
    "Incorrect stock quantity",
    "Stock adjustment issue",
    "Stock transfer issue",
    "Purchase/GRN issue",
    "Sale/dispensing issue",
    "Stock consumption issue",
    "Batch/expiry issue",
    "Low-stock/reorder issue",
    "Incorrect inventory valuation",
    "Inventory report issue",
    "Other inventory issue",
  ],
  Diagnostics: [
    "Unable to create diagnostic order",
    "Diagnostic order not visible",
    "Sample collection issue",
    "Order status incorrect",
    "Results not updated",
    "Unable to enter diagnostic result",
    "Result not appearing in EMR",
    "Diagnostic report issue",
    "External lab integration issue",
    "Other diagnostics issue",
  ],
  "Reports & Documents": [
    "Report not generating",
    "Incorrect report data",
    "Report missing information",
    "Unable to download report",
    "Unable to print document",
    "Invoice/receipt document issue",
    "EMR document issue",
    "Custom report request",
    "Other reporting issue",
  ],
  "User & Access Management": [
    "Unable to create user",
    "Unable to deactivate user",
    "Incorrect user permissions",
    "User cannot access module",
    "User cannot access branch",
    "Incorrect role/access",
    "Staff invitation issue",
    "Other user/access issue",
  ],
  "Performance & Technical Issues": [
    "Application is slow",
    "Page taking too long to load",
    "Search is slow",
    "Billing is slow",
    "Inventory is slow",
    "EMR is slow",
    "Reports are slow",
    "Login is slow",
    "Application not responding",
    "Error message displayed",
    "Unexpected application behaviour",
    "Page/module not loading",
    "Data not refreshing",
    "System unavailable",
    "Other technical issue",
  ],
  "Hardware & Printing": [
    "Printer not printing",
    "Incorrect print format",
    "Silent printing not working",
    "Dot-matrix printing issue",
    "Receipt printer issue",
    "Barcode printer issue",
    "Scanner/device issue",
    "Hardware connection issue",
    "Other hardware issue",
  ],
  "How-To / Training": [
    "How do I create a pet?",
    "How do I create an appointment?",
    "How do I complete a consultation?",
    "How do I create a bill?",
    "How do I record a payment?",
    "How do I issue/dispense inventory?",
    "How do I perform stock adjustment?",
    "How do I transfer inventory?",
    "How do I create a diagnostic order?",
    "How do I generate a report?",
    "How do I manage users?",
    "How do I configure clinic settings?",
    "How do I use [module]?",
    "Training request",
    "Other how-to question",
  ],
  "Feature Request": [
    "New feature request",
    "Enhancement to existing feature",
    "Workflow improvement",
    "New report/request",
    "Integration request",
    "New configuration option",
    "Automation request",
    "Other product suggestion",
  ],
  Other: ["Other issue"],
};

export const SUPPORT_PROBLEM_TYPES = [
  "I can't do something",
  "Something is not working",
  "Something is incorrect",
  "Something is missing",
  "I don't know how to do something",
  "I need a change/enhancement",
];

export const toSelectList = (items = []) =>
  (items ?? []).map((item) => ({ name: item, value: item }));
